export const beneficiosImage =
    'https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/header-clube-do-aluno.png';
export const cuponsImage =
    'https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/header-cupons.png';